import React from 'react'
import { Link } from "react-router-dom";
import './Home.css'


const Home = () => {
    return (
        <section className='home'>
            <video
                autoPlay
                loop
                muted
                className="video-background"
            >
                <source src="/video_inicial.mp4" type="video/mp4" />
                Tu navegador no soporta el elemento de video.
            </video>

            <div className="accion-btn">
                <Link to="https://wa.me/573188959559">RESERVA AQUÍ</Link>
            </div>
            <div className="header-contact">
                <div className="info-contact">
                    <p>RESERVA TELEFÓNICA</p>
                    <span><a href="tel:+573188959559" className="text-decoration-none">+57 318 895 9559</a></span>
                </div>
                <div className="icon-contact">
                    <i className="ri-phone-line"></i>
                </div>
            </div>
        </section>
    )
}

export default Home
